import React, { useState } from "react"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"
import PropTypes from "prop-types"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../api"
import Select from "react-select";

const AddQuartExamen = props => {
  const [name, setName] = useState("")
  const [semestre, setSemestre] = useState([
    {value: 1, label: "Semestre 1"},
    {value: 2, label: "Semestre 2"},
  ])
  const [selectSemestre, setSelectSemestre] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  const save = async () => {
    if (name !== "" &&  selectSemestre !== "") {
      const res = await API.post("quart/examen/add", {
        name: name,
        annee_id,
        semestre_id:selectSemestre.value
      })
        .then(res => {
          props.setSection(1)
        })
    } else {
      toast.error("⛔ Quart et semestre sont obligatoire", {
        containerId: "A",
      })
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Form>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Semestre:</Label>
                <Select
                    options={semestre}
                    isSearchable={true}
                    isClearable={true}
                    onChange={e => setSelectSemestre(e)}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Quart</Label>
                <Input
                  lg="3"
                  type="text"
                  className="form-control"
                  placeholder="Quart d'examen"
                  onChange={e => setName(e.target.value)}
                />
              </div>
            </Col>
          </Row>
        </Form>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {" "}
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              className="text-center mt-4"
            >
              <Button
                type="button"
                color="warning"
                className="btn btn-warning  mb-2 me-2"
                onClick={props.back}
              >
                Annuler
              </Button>
            </div>
          </Col>
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
              className="text-center mt-4"
            >
              <button type="button" className="btn btn-primary " onClick={save}>
                CONFIRMER
              </button>
            </div>
          </Col>
        </div>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default AddQuartExamen
AddQuartExamen.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
}
